//New code

import { Component } from "@theme/component";

export class VideoBackgroundComponent extends Component {
  requiredRefs = ["videoSources", "videoElement"];

  connectedCallback() {
    super.connectedCallback();
    this.initVideo();
  }

  initVideo() {
    const { videoSources, videoElement } = this.refs;
    if (!videoElement || !videoSources) return;

    const sources = Array.isArray(videoSources) ? videoSources : [videoSources];
    const posterImage = this.querySelector("img");

    const normaliseUrl = (url) => {
      if (!url) return "";
      return url.startsWith("//") ? `${window.location.protocol}${url}` : url;
    };

    const mp4Source = sources.find((source) =>
      (source.dataset.videoSource || "").includes(".mp4")
    );

    const hlsSource = sources.find((source) =>
      (source.dataset.videoSource || "").includes(".m3u8")
    );

    const showVideo = () => {
      this.classList.add("is-playing");
      videoElement.style.opacity = "1";
      if (posterImage) {
        posterImage.style.opacity = "0";
        posterImage.style.visibility = "hidden";
        posterImage.style.pointerEvents = "none";
      }
    };

    const showPoster = () => {
      this.classList.remove("is-playing");
      videoElement.style.opacity = "0";
      if (posterImage) {
        posterImage.style.opacity = "1";
        posterImage.style.visibility = "visible";
        posterImage.style.pointerEvents = "auto";
      }
    };

    const clearAllSourceSrc = () => {
      sources.forEach((source) => source.removeAttribute("src"));
    };

    const tryPlay = () => {
      const playPromise = videoElement.play();

      if (playPromise && typeof playPromise.then === "function") {
        playPromise
          .then(() => {
            showVideo();
          })
          .catch(() => {
            showPoster();
          });
      }
    };

    const loadMp4Only = () => {
      clearAllSourceSrc();

      if (mp4Source) {
        mp4Source.setAttribute("src", normaliseUrl(mp4Source.dataset.videoSource));
      }

      videoElement.load();
      tryPlay();
    };

    const loadHlsThenFallback = () => {
      clearAllSourceSrc();

      if (hlsSource) {
        hlsSource.setAttribute("src", normaliseUrl(hlsSource.dataset.videoSource));
      }

      if (mp4Source) {
        mp4Source.setAttribute("src", normaliseUrl(mp4Source.dataset.videoSource));
      }

      videoElement.load();
      tryPlay();
    };

    videoElement.muted = true;
    videoElement.defaultMuted = true;
    videoElement.autoplay = true;
    videoElement.loop = true;
    videoElement.playsInline = true;
    videoElement.preload = "metadata";

    videoElement.setAttribute("muted", "");
    videoElement.setAttribute("autoplay", "");
    videoElement.setAttribute("loop", "");
    videoElement.setAttribute("playsinline", "");
    videoElement.setAttribute("webkit-playsinline", "");

    videoElement.addEventListener("playing", showVideo, { once: true });
    videoElement.addEventListener("loadeddata", showVideo, { once: true });

    videoElement.addEventListener(
      "error",
      () => {
        if (mp4Source) {
          loadMp4Only();
        } else {
          showPoster();
        }
      },
      { once: true }
    );

    // Prefer MP4 first for maximum compatibility
    if (mp4Source) {
      loadMp4Only();
    } else {
      loadHlsThenFallback();
    }
  }
}

if (!customElements.get("video-background-component")) {
  customElements.define("video-background-component", VideoBackgroundComponent);
}

